import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { fetchReclamationRecepissesSuiviColis } from 'utils/fetchers';



import withLoader from 'components/Shared/withLoader';

import TransporteurLinks from './TransporteurLinks';

const TransporteurLinksWithLoader = withLoader(TransporteurLinks);

class TransporteurLinksContainer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            login: '',
            pwd: '',
            urls: null,
            transporteur: null,
            isLoading: true
        };
    }


    async componentDidMount() {
        const { reclamationId } = this.props;

        var result = await this.props.fetchReclamationRecepissesSuiviColis(reclamationId);

        this.setState({ ...result, isLoading: false });
    }


    render() {

        const { fallbackComponent, onClickDone, isAdding, fallbackMode, onClickFallback } = this.props;

        const { isLoading, login, pwd, urls, transporteur, error } = this.state;



        if (!transporteur && !isLoading) {
            return fallbackComponent;
        }

        if (error) {
            return fallbackComponent;
        }
               
        return (
            <TransporteurLinksWithLoader
                isLoading={isLoading}
                urlSuiviColis={urls}
                login={login}
                pwd={pwd}
                transporteurNom={transporteur ? transporteur.nom : ''}

                onClickDone={onClickDone}
                isAdding={isAdding}

                onClickFallback={onClickFallback}

                fallbackMode={fallbackMode}
                fallbackComponent={fallbackComponent}
            />
        );
    }
}

TransporteurLinksContainer.propTypes = {
    reclamationId: PropTypes.number.isRequired
};



const mapDispatchToProps = {
    fetchReclamationRecepissesSuiviColis
};


export default connect(null, mapDispatchToProps)(TransporteurLinksContainer);